
export default class Api{

    baseUrl = '';

    constructor(){
	this.setBaseUrl = this.setBaseUrl.bind(this);
	this.commonParseResponse = this.commonParseResponse.bind(this);
    }

    setBaseUrl(url){
	this.baseUrl = url;
    }

    callExternURL(configuration){
        const conf = {
            url: configuration.url,
            method: configuration.method?configuration.method:'GET',
            headers: configuration.headers?configuration.headers: {},
            successCallback: configuration.successCallback?configuration.successCallback: function(){},
            errorCallback: configuration.errorCallback?configuration.errorCallback: function(){},
            completeCallback: configuration.completeCallback?configuration.completeCallback: function(){},
        };

        if(configuration.body) conf.body = configuration.body;
        const parseResponse = configuration.downloadFile?this.downloadParseResponse:this.commonParseResponse;
        fetch(conf.url , {
            crossDomain:true,
            method: conf.method,
            headers: conf.headers,
            body: conf.body
            }
        ).then(parseResponse)
        .catch( error => {
	        conf.errorCallback();
       		conf.completeCallback(error);
        })
        .then(response => {
            response === undefined? conf.errorCallback(response):conf.successCallback(response); 
            conf.completeCallback(response);
        });

    }

    commonParseResponse(res){
	return res.json();
    }

    downloadParseResponse(res){
	return res.blob();
    }

    commonPostApiCall(hasToken, method, arrayParams, url, callback, errorCallback, downloadFile, headers){
        let conf = {
            url: this.baseUrl + url,
            method: method,
            headers: headers?headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            successCallback: callback,
            errorCallback: errorCallback,
            downloadFile: downloadFile
        };
        
        if(arrayParams.length > 0 || typeof(arrayParams) === 'object'){
            //Modo elegante. Tambien se pueden concatenar los parametros con ampersand como una URL
            //Ej: const body = 'email='+email+'&password='+password;
            if(method === 'GET'){
            	    if(arrayParams.length > 0){
			conf.url +='?';
		    }
		    let count = 0;
		    arrayParams.forEach(element => {
		    	    if(++count > 1) conf.url +='&';
			    conf.url +=element.name+'='+element.value;
		    });

	    }else{
		    let body = new URLSearchParams();
		    if(arrayParams.length > 0){
			    arrayParams.forEach(element => {
				    body.set(element.name, element.value);
			    });
		    }else if(arrayParams.append && typeof arrayParams.append === 'function'){
		    	//Cuando nos llega un FormData el body debe ser directamente ese FormData
		    	body = arrayParams;

		    }else{
			for(let prop in arrayParams){
				body.set(prop, arrayParams[prop]);
			}
		    }
		    conf.body = body;
	    }
        }

        if(hasToken){
            conf.headers["x-access-token"] = this.getToken();
        }
	
	this.callExternURL(conf);
    }
}
